import React from 'react';

// IMAGES
import waitingIcon from '../../images/waiting.png';

import './MonthlyCard.less';

export const MonthlyCard = (props) => {
  const { theme } = props;

  return (
    <div className={`monthly-card monthly-card-${theme}`}>
      <div className="monthly-card--header">
        <div className="monthly-card--title">Monthly Period</div>
      </div>
      <div className="monthly-card--content">
        <div className="monthly-savings-waiting">
          <img src={waitingIcon} alt="monthly waiting" className="modal-savings-waiting" />
          <div className="monthly-savings-text-main">We are collecting data right now</div>
          <div className="monthly-savings-text-secondary">
            Your savings will appear after software implementation period is complete
          </div>
        </div>
      </div>
    </div>
  );
};
